import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57322c05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "expandable-content" }
const _hoisted_2 = { class: "placeholder flex flex-center" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "label-cell" }


import { actionHandler } from '@/actions/actionHandler';
import { ExpandableContent, TableColumn, TableRow } from '@/components/TableComponent/types';
import { defineAsyncComponent, PropType } from 'vue';
import AppLoader from '@/components/AppLoader.vue';
import CustomButton from './CustomButton.vue';
import PinIconButton from './PinIconButton.vue';
import { defineCellProps, defineComponentName } from './composables';

const __default__ = {
  name: 'ExpandableContent',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object as PropType<TableRow>,
    default: () => {},
  },
  columns: {
    type: Array as PropType<TableColumn[]>,
    default: () => [],
  },
  additional: {
    type: Array as PropType<ExpandableContent[]>,
    default: () => [],
  },
},
  emits: ['unhideColumn'],
  setup(__props, { emit }) {

const props = __props



const contentTypes = {
  button: CustomButton,
  component: defineAsyncComponent(
    () => import(`~components/expandables/${props.additional[0].value}.vue`),
  ),
};



const defineAdditionalComponent = (component: ExpandableContent) => contentTypes[component.type];

props.additional.forEach(async (component) => {
  if (component.action) {
    const customParam = JSON.stringify(props.data);
    await actionHandler({ ...component.action, customParam });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.additional.length)
      ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
          fallback: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AppLoader)
            ])
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.additional, (component, index) => {
              return (_openBlock(), _createBlock(_resolveDynamicComponent(defineAdditionalComponent(component)), {
                key: index,
                value: component.value,
                data: __props.data
              }, null, 8, ["value", "data"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.columns.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(column.colname) + " ", 1),
                    (column.description)
                      ? (_openBlock(), _createBlock(_component_q_tooltip, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(column.description), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", null, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(defineComponentName)(__props.columns[index])), _mergeProps({ class: "block" }, _unref(defineCellProps)(__props.columns[index], __props.data[__props.columns[index].name_column]), {
                    actionParams: Object.assign(__props.data, __props.columns[index]?.value?.action?.customParam),
                    onAction: _unref(actionHandler)
                  }), null, 16, ["actionParams", "onAction"]))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})